import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { ClientProvider } from "@silo/types";

export const useBlockNumber = (clientProvider?: ClientProvider) => {
  const { data: fetchedBlockNumber } = useQuery({
    queryKey: ["blockNumberKey", clientProvider!],
    queryFn: () => fetchBlockNumber(clientProvider!),
    enabled: !!clientProvider,
  });

  const [updatedBlockNumber, setUpdatedBlockNumber] = useState<
    number | undefined
  >(undefined);

  useEffect(() => {
    if (!clientProvider) return;

    const callback = (blockNumber: number) =>
      setUpdatedBlockNumber(blockNumber);

    clientProvider.on("block", callback);

    return () => {
      clientProvider.removeListener("block", callback);
    };
  }, [clientProvider]);

  return updatedBlockNumber ?? fetchedBlockNumber;
};

const fetchBlockNumber = (clientProvider: ClientProvider) =>
  clientProvider.getBlockNumber();
